<script setup lang="ts">
import { useItemStore } from "@/itemStore";
import type { Term } from "@/itemStore";
import { computed, ref } from "vue";

const props = defineProps<{
  term: Term;
  taxonomy: string;
}>();
const itemStore = useItemStore();

const filter = computed(() => {
  return itemStore.getFilter(props.taxonomy);
});

const openMenu = ref(false);

const getClass = computed(() => {
  let className = "btn";
  if (
    (filter.value.length === 0 && props.term.slug === "") ||
    filter.value.includes(props.term.slug)
  ) {
    className += " active";
  }
  return className;
});

const getActiveClass = computed(() => {
  if (filter.value.includes(props.term.slug)) {
    return "active";
  }
  return "";
});

const getMenuClass = computed(() => {
  let className = "btn-dropdown-menu";
  if (openMenu.value) {
    className += " active";
  }
  return className;
});

const getTerm = computed((): Term => {
  if (filter.value.includes(props.term.slug)) {
    return props.term;
  }
  for (let term of props.term.children) {
    if (filter.value.includes(term.slug)) {
      return term;
    }
  }
  return { id: 0, slug: "", name: "", order: -1, children: [] };
});

const setFilter = (slug: string) => {
  itemStore.setFilter(props.taxonomy, slug, itemStore.settings.filterRadio);
};

const toggleMenu = () => {
  openMenu.value = !openMenu.value;
};

const setValue = (slug: string) => {
  itemStore.setFilter(props.taxonomy, slug);
  toggleMenu();
};
</script>

<template>
  <button v-if="term.children.length === 0" :class="getClass" @click="setFilter(term.slug)">
    {{ term.name }}
  </button>
  <button v-else-if="getTerm.id > 0" :class="getClass" @click="setFilter(getTerm.slug)">
    {{ getTerm.name }}
  </button>
  <div v-else class="dropdown-container">
    <button :class="getClass" @click="toggleMenu">
      {{ term.name }}
    </button>
    <div :class="getMenuClass">
      <button :class="getActiveClass" @click="setValue(term.slug)">
        {{ term.name }}
      </button>
      <button
        v-for="child in term.children"
        :key="child.slug"
        :class="getActiveClass"
        @click="setValue(child.slug)"
      >
        {{ child.name }}
      </button>
    </div>
  </div>
</template>
